<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="opentherm-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <img ngSrc="/assets/img/zone_icons/light/opentherm-light.svg"
                    width="45" height="45" alt="" />
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ subtitle(3645) }}
            </p>
        </div>
        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="close-control"
                    (click)="zones.goHome()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>

            <div class="zone-control__current-temp zone-control__current-temp--first font-34">
                <span>{{ subtitle(2585) + '&nbsp;' }}</span>
                <span class="color-dark">
                    {{ zones.selectedZone.tile.params.currentTemp | format:7 }}
                </span>
            </div>
            <div class="zone-control__set-temp zone-control__set-temp--mini bg-settings bg-settings--zone font-bold color-alarm">
                <p class="zone-control__set-temp-value">
                    {{ zones.selectedZone.tile.params.setCurrentTemp | format:7 }}
                </p>
            </div>

            <div class="zone-control__current-temp zone-control__current-temp--second font-34">
                <span>{{ subtitle(2586) + '&nbsp;' }}</span>
                <span class="color-dark">
                    {{ zones.selectedZone.tile.params.currentTempDHW | format:7 }}
                </span>
            </div>
            <div class="zone-control__set-temp zone-control__set-temp--mini bg-settings bg-settings--zone font-bold color-alarm">
                <p class="zone-control__set-temp-value">
                    {{ zones.selectedZone.tile.params.setTempDHW | format:7 }}
                </p>
            </div>

            <div class="zone-control__mode-select zone-control__mode-select--valve font-bold">
                <div class="zone-control__select"
                    *ngIf="zones.selectedZone.tile.menuId !== 0">
                    <div class="zone-control__select-icon"
                        (click)="zones.goToMenu(zones.selectedZone.tile, zones.selectedZone.tile.submenuElementId)">
                        <icon [iconName]="'menu-fitters'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'menu-fitters'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                    </div>
                    <p>{{ subtitle(388) }}</p>
                </div>
                <div class="zone-control__select zone-control__select--settings">
                    <div class="zone-control__select-icon"
                        (click)="zones.goToState('opentherm_info')" >
                        <icon [iconName]="'settings'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--white'">
                        </icon>
                        <icon [iconName]="'settings'"
                             [iconSize]="80"
                             [className]="'zone-control__select-icon cursor-pointer zone-control__select-icon--style fill-icon fill-icon--warning'">
                        </icon>
                    </div>
                    <p>{{ subtitle(3709) }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
